
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { IReviewType } from '@/Interfaces';
  import { ReviewTypeSource } from '@/Sources';

  @Component({
    name: 'review-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class ReviewTypeDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Review Type' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop() public importProcessId!: number | null;
    @Prop({ type: Boolean, default: false }) public inline!: boolean;
    @Prop({ default: '' }) public indent!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ default: () => null }) public onlyImportProcess!: boolean | null;
    @Prop({ default: () => null }) public isException!: boolean | null;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;

    public source: ReviewTypeSource = new ReviewTypeSource();
    public innerValue: IReviewType | null = null;

    public get val(): IReviewType | null { return this.innerValue; }
    public set val(value: IReviewType | null) {
      this.$emit('input', value?.id ?? '');
      this.$emit('import-process-id', value?.importProcessId ?? null);
      this.$emit('review-type', value);
      this.innerValue = value;
    }

    public mounted() {
      this.source = new ReviewTypeSource(null, this.onlyImportProcess, this.isException);
    }

    @Watch('value', { immediate: true })
    public onValueChange(newValue: string) {
      if (this.source.isLoaded) {
        this.val = this.source.items.find(x => x.id === newValue) ?? null;
      }
    }

    @Watch('importProcessId')
    public onImportProcessIdChange(newImportProcessId: number | null) {
      this.source.items
      this.source = new ReviewTypeSource(newImportProcessId);
    }

    @Watch('source.cachedItems', { immediate: true })
    public onSourceItemsChange(newSourceItems: IReviewType[]) {
      if (this.source.isLoaded) {
        this.val = newSourceItems.find(x => x.id === this.value) ?? null;
        this.$emit('items', newSourceItems);
      }
    }

    @Watch('source', { immediate: true })
    public onSourceChange(newSource: ReviewTypeSource) {
      this.$emit('source', newSource);
    }
  }
